import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import omit from 'lodash/omit';

import FieldsetList from '../FieldSetList';
import { PROFILE_SECTIONS } from '../../../constants';
import ContactInfoSection from '../ContactInfoSection';
import deepTrim from '../../../utils/converters/deepTrim';
import { getProviderFieldsetList } from '../utils/getFieldset';
import { getContactsConditions } from '../utils/getContactConditions';
import toSnakeCaseObjectKeys from '../../../utils/toSnakeCaseObjectKeys';
import { EMERGENCY_CONTACT_DATA_KEY } from '../../../constants/metadata';
import { enhance } from './enhance';
import { HomeAddress } from '../HomeAddress';

const ProviderProfile = props => {
  const {
    profile,
    saveUser,
    savePatient,
    canEdit,
    profileEditable,
    intl: { formatMessage },
    countryList,
    isSucceedUpdate,
  } = props;
  const { id, email, phoneNumber } = profile;
  const { showEmail, showPhoneNumber } = getContactsConditions(profile);

  const patientProfileId = get(profile, 'primaryPatientProfile.id');

  const handleSave = (data, type) => {
    if (type === PROFILE_SECTIONS.EMERGENCY_CONTACT) {
      savePatient({
        [EMERGENCY_CONTACT_DATA_KEY]: toSnakeCaseObjectKeys(data),
        id: patientProfileId,
      });
      return;
    }

    // exclude ssn, because it's with *
    const checkedData = deepTrim(profileEditable ? data : omit(data, ['ssn']));

    saveUser({ ...checkedData, id });
  };

  return (
    <Fragment>
      <ContactInfoSection
        canEdit={canEdit}
        email={showEmail ? email : null}
        phoneNumber={showPhoneNumber ? phoneNumber : null}
      />
      <FieldsetList
        fieldSetList={getProviderFieldsetList(props)}
        onSave={handleSave}
        disabled={!canEdit}
        canEdit={canEdit}
      />
      <HomeAddress
        formatMessage={formatMessage}
        profile={profile}
        canEdit={canEdit}
        countryList={countryList}
        saveUser={saveUser}
        isSucceedUpdate={isSucceedUpdate}
      />
    </Fragment>
  );
};

ProviderProfile.propTypes = {
  profile: PropTypes.object,
  saveUser: PropTypes.func,
  savePatient: PropTypes.func,
  canEdit: PropTypes.bool,
  profileEditable: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  countryList: PropTypes.array,
  isSucceedUpdate: PropTypes.bool,
};

export default enhance(ProviderProfile);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProviderProfile/index.jsx